import { render, staticRenderFns } from "./WarehouseCard.vue?vue&type=template&id=d00a61cc&scoped=true"
import script from "./WarehouseCard.vue?vue&type=script&lang=js"
export * from "./WarehouseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00a61cc",
  null
  
)

export default component.exports